import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "./Breadcrumb";
import Select from "react-select";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { API_URL } from "..";
import { Card, Form } from "react-bootstrap";
import swal from "sweetalert";

const DriverAssignmentPage = () => {
  const [drivers, setDrivers] = useState([]);
  const [trucks, setTrucks] = useState([]);
  const [driverAssignments, setDriverAssignments] = useState({});
  const [searchQuery, setSearchQuery] = useState(""); // 🔍 Search Query

  useEffect(() => {
    const value = JSON.parse(localStorage.getItem("user"));
    if (!value || !value.id) return;

    const fetchDrivers = async () => {
      try {
        const response = await fetch(`${API_URL}/api/driver/fetch/${value.id}`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        const data = await response.json();
        setDrivers(data.data);

        // Create an object mapping driverId -> assigned truck
        const assignments = {};
        data.data.forEach(driver => {
          if (driver.truck_id) {
            assignments[driver.id] = driver.truck.name || null;
          }
        });
        setDriverAssignments(assignments);
      } catch (error) {
        console.error("Error fetching drivers:", error);
      }
    };

    const fetchTrucks = async () => {
      try {
        const response = await fetch(`${API_URL}/api/truck/${value.id}`, {
          method: "GET",
        });
        const data = await response.json();
        setTrucks(data.truck || []);
      } catch (error) {
        console.error("Error fetching trucks:", error);
      }
    };

    fetchDrivers();
    fetchTrucks();
  }, []);

  const handleTruckChange = async (selectedOption, driverId) => {
    if (!selectedOption) return;
  
    const value = JSON.parse(localStorage.getItem("user"));
    if (!value || !value.id) return;
  
    const requestBody = {
      driver_id: driverId,
      truck_id: selectedOption.value, // Assuming `value` holds truck_id
    };
  
    try {
      const response = await fetch(`${API_URL}/api/truck/assign-truck`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
  
      const data = await response.json();
  
      if (response.ok) {
        // ✅ API Success: Update the selected truck in state
        setDriverAssignments((prev) => ({
          ...prev,
          [driverId]: selectedOption.label,
        }));
        swal("Truck Assigned","Truck is successfully assigned to the driver", "success");
      } else {
        // ❌ API Error: Show error and do not change selection
        swal("Error" , data.message || "Failed to assign truck. Please try again." , 'error');
      }
    } catch (error) {
      console.error("Error updating truck assignment:", error);
      swal("Error","An error occurred. Please try again.", "error");
    }
  };
  

  // 🔍 Filter Drivers Based on Search Query
  const filteredDrivers = drivers?.filter(driver =>
    driver.first_name.toLowerCase().includes(searchQuery.toLowerCase())
  ) || [];

  return (
    <MasterLayout>
      <Breadcrumb title="Driver Assignments" />
      <div className="row">
        <div className="col-md-12">
          <Card className="p-3">
            <h2 className="text-xl font-bold mb-4">Assign Trucks to Drivers</h2>

            {/* 🔍 Search Input */}
          

            <Card.Body>
            <div className="col-md-4 mt-3">
           <Form.Control
              type="text"
              placeholder="Search Driver..."
              className="mb-3"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
           </div>
              <Table className=" border border-gray-300">
                <Thead>
                  <Tr className="bg-gray-200">
                    <Th className="p-3 border">Driver Name</Th>
                    <Th className="p-3 border">Truck Assignment</Th>
                    <Th className="p-3 border">Last Update</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {filteredDrivers.length > 0 ? (
                    filteredDrivers.map((driver) => (
                      <Tr key={driver.id} className="hover:bg-gray-100">
                        <Td className="p-3 border">{driver?.first_name} {driver?.last_name}</Td>
                        <Td className="p-3 border">
                          <Select
                            options={[
                              { value: "", label: "Select Truck" },
                              ...trucks.map((truck) => ({ value: truck.id, label: truck.name })),
                            ]}
                            value={
                              driverAssignments[driver.id]
                                ? { value: driverAssignments[driver.id], label: driverAssignments[driver.id] }
                                : { value: "", label: "Select Truck" }
                            }
                            onChange={(selectedOption) => handleTruckChange(selectedOption, driver.id)}
                            isClearable
                          />
                        </Td>
                        <Td className="p-3 border">{new Date(driver.updatedAt).toLocaleString()}</Td>
                      </Tr>
                    ))
                  ) : (
                    <Tr>
                      <Td colSpan="3" className="text-center p-3">
                        No drivers found
                      </Td>
                    </Tr>
                  )}
                </Tbody>
              </Table>
            </Card.Body>
          </Card>
        </div>
      </div>
    </MasterLayout>
  );
};

export default DriverAssignmentPage;
